const shopsSellingWithUsPage = {
  displayField: 'title',
  name: 'Selling With Us page',
  description: '"Selling With Us" page',
  fields: [
    {
      id: 'title',
      name: 'Admin Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'category',
      name: 'Category',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'category' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'seo',
      name: 'Seo',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: true,
      omitted: true,
      linkType: 'Entry'
    },
    {
      id: 'heroImg',
      name: 'Hero Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: true,
      omitted: true,
      linkType: 'Asset'
    },
    {
      id: 'contentBlocks',
      name: 'Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'shopGridCarousel',
              'shortTextAndImage',
              'video',
              'videoGallery',
              'bigPictureCta',
              'stackedTextImageBlock',
              'textAndImageBlock',
              'variantStackedTextImageBlock',
              'flexCollar',
              'introTextBlock',
              'searchHero',
              'interiorHero',
              'threeColumn',
              'threeColumnContent',
              'wideTextImage',
              'blogHomepageFeaturedArticles',
              'shopNewestListings',
              'featuredPropertiesByLifestyle',
              'WideStackedTextImageBlock',
              'threeColumnTeams',
              'clientTestimonials',
              'contactForm',
              'statBlock',
              'valuePropCarousel',
              'jazzHr',
              'richText',
              'newsletterForm',
              'mediaContactInfo',
              'nearbyListings',
              'genericEmbed'
            ]
          }
        ],
        linkType: 'Entry'
      }
    },
    {
      id: 'myHomeWorthEmbedCode',
      name: 'MyHomeWorthEmbedCode',
      type: 'Text',
      localized: false,
      required: true,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'embedCodes',
      name: '"My Home Worth" Embed codes',
      type: 'Object',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'hero',
      name: 'Hero',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'interiorHero' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'textAndImageBlock1',
      name: 'Get In Touch - Text and Image Block1',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'textAndImageBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'myHomeWorthEmbed',
      name: 'MyHomeWorth Embed',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'genericEmbed' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'textAndImageBlock2',
      name: 'Home Valuation - Text And Image Block2',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'textAndImageBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'threeColumnContentBlock',
      name: 'The EV Difference Block - Three Column Content',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'threeColumnContent' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'textAndImageBlock3',
      name: 'Who We Are - Text and Image Block3',
      type: 'Link',
      localized: false,
      required: false,
      validations: [
        {
          linkContentType: [ 'textAndImageBlock' ],
          message: "Only populate to replace default Hero on America's /selling-with-us page"
        }
      ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'textAndImageBlock4',
      name: "Seller's Guide - Text and Image Block4",
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'textAndImageBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'wideTextImageBlock',
      name: 'Buy With Us - Wide Text Image Block',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'wideTextImage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'blogHeader',
      name: 'Blog Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'featuredArticles',
      name: 'Featured Articles',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'blogHomepageFeaturedArticles' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'viewAllArticlesButtonText',
      name: 'View All Articles Button Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'dynamicContentBlocks',
      name: 'Dynamic Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'StackedTextImageForm',
              'wideTextImage',
              'WideStackedTextImageBlock',
              'textAndImageBlock'
            ]
          }
        ],
        linkType: 'Entry'
      }
    },
    {
      id: 'contact',
      name: 'Contact',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'contactForm' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ]
    }
  },
  sys: {
    id: 'shopsSellingWithUsPage',
    version: 40,
    updatedAt: '2023-11-28T01:37:49.008Z'
  }
};
export default shopsSellingWithUsPage;